// extracted by mini-css-extract-plugin
export default {"NavItem":"Tabs_NavItem__qpcfa","ActiveNavItem":"Tabs_ActiveNavItem__8q5po","Menu":"Tabs_Menu__VmE1A","Text":"Tabs_Text__N+FBw"};